export default __webpack_public_path__ + "static/media/coin.96a45bd3.svg";